import {
  createPreviewsForXmlDoc,
  extractTightBoundsFromLogoXml,
  generateInvertedPreview,
  generateLogoVariants,
} from '../lib/helpers/logos'

export const state = () => ({
  base64TightBounds: undefined,
  base64TightBoundsWhite: undefined,
  base64TightBoundsBlack: undefined,
  base64TightBoundsInverted: undefined,
  base64TightBoundsWidth: undefined,
  base64TightBoundsHeight: undefined,

  currentLogoId: undefined,
  currentLogoUpdatedAt: undefined,
  variants: {},
  updating: false,
})

export const mutations = {
  setWhitePreview(state, value) {
    state.base64TightBoundsWhite = value
  },
  setBlackPreview(state, value) {
    state.base64TightBoundsBlack = value
  },
  setInvertedPreview(state, value) {
    state.base64TightBoundsInverted = value
  },
  setPreview(state, value) {
    state.base64TightBounds = value
  },
  setWidth(state, value) {
    state.base64TightBoundsWidth = value
  },
  setHeight(state, value) {
    state.base64TightBoundsHeight = value
  },
  setUpdating(state, value) {
    state.updating = value
  },
  setLogoUpdatedAt(state, value) {
    state.currentLogoUpdatedAt = value
  },
  setLogoId(state, value) {
    state.currentLogoId = value
  },
  setVariants(state, value) {
    state.variants = value
  },
}

export const actions = {
  /**
   * Generate all the logo variants needed for displaying file previews on the dashboard
   * @param {*} newLogo logo object to generate variants for
   */
  async updateLogo({ state, commit }, newLogo) {
    try {
      const variants = await generateLogoVariants(newLogo, process.env.API_BASE)
      commit('setVariants', variants)
    } catch (error) {
      console.log('error', error)
    }

    commit('setUpdating', true)
    commit('setLogoId', newLogo.id)
    commit('setLogoUpdatedAt', newLogo.updated_at)

    try {
      const tight_bounds_dom = extractTightBoundsFromLogoXml(newLogo.svg)

      const width = parseInt(tight_bounds_dom.getAttribute('width'))
      const height = parseInt(tight_bounds_dom.getAttribute('height'))

      commit('setWidth', width)
      commit('setHeight', height)

      const previews = createPreviewsForXmlDoc(tight_bounds_dom)

      commit('setPreview', previews.default)
      commit('setBlackPreview', previews.black)
      commit('setWhitePreview', previews.white)

      const inverted = generateInvertedPreview(
        tight_bounds_dom,
        newLogo.assets.palette
      )
      commit('setInvertedPreview', inverted)
    } catch (error) {
      console.log('error', error)
    }
    commit('setUpdating', false)
  },
}
